var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0659 10C23.9978 10 23.1319 10.8597 23.1319 11.9201C23.1319 12.1862 23.1864 12.4396 23.285 12.67L19.2335 16.6923C19.0015 16.5944 18.7462 16.5402 18.4782 16.5402C18.2102 16.5402 17.955 16.5944 17.7229 16.6923L15.3028 14.2895C15.4013 14.0592 15.4559 13.8058 15.4559 13.5397C15.4559 12.4792 14.5899 11.6195 13.5218 11.6195C12.4537 11.6195 11.5878 12.4792 11.5878 13.5397C11.5878 13.8057 11.6423 14.0591 11.7408 14.2895L7.68936 18.3118C7.45732 18.2139 7.20207 18.1597 6.93406 18.1597C5.86593 18.1597 5 19.0194 5 20.0799C5 21.1403 5.86593 22 6.93406 22C8.0022 22 8.86812 21.1403 8.86812 20.0799C8.86812 19.8138 8.81358 19.5604 8.71504 19.33L12.7665 15.3078C12.9986 15.4056 13.2538 15.4598 13.5218 15.4598C13.7898 15.4598 14.045 15.4056 14.2771 15.3078L16.6973 17.7106C16.5987 17.9409 16.5442 18.1943 16.5442 18.4604C16.5442 19.5208 17.4101 20.3805 18.4782 20.3805C19.5464 20.3805 20.4123 19.5208 20.4123 18.4604C20.4123 18.1943 20.3578 17.9409 20.2592 17.7106L24.3106 13.6882C24.5427 13.7861 24.7979 13.8402 25.0659 13.8402C26.1341 13.8402 27 12.9805 27 11.9201C27 10.8596 26.1341 10 25.0659 10Z",
    fill: "#565656",
    stroke: "#565656",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesOne);
export default __webpack_public_path__ + "static/media/features-one.29613fec.svg";
export { ForwardRef as ReactComponent };